import { useState, useEffect } from 'react';

/**
 * Hook to fetch terms content from HTML files
 * @param {string} type - 'user' or 'partner'
 * @returns {{ content: string, loading: boolean, error: string | null }}
 */
export const useTermsContent = (type = 'user') => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const fileName = type === 'partner' ? 'terms-partner.html' : 'terms-user.html';
        const response = await fetch(`/${fileName}`);
        
        if (!response.ok) {
          throw new Error('Failed to load terms content');
        }
        
        const html = await response.text();
        
        // Extract just the content div from the HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const contentDiv = doc.querySelector('.content');
        
        if (contentDiv) {
          setContent(contentDiv.innerHTML);
        } else {
          // Fallback: extract body content
          const body = doc.querySelector('body');
          setContent(body ? body.innerHTML : html);
        }
      } catch (err) {
        console.error('Error loading terms:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, [type]);

  return { content, loading, error };
};

export default useTermsContent;
